import { RequestUserConfig } from '../common/types'
import { NetworkService } from '../services'
import { BaseTransport } from '../transports'
import { ABConfigResponseTransport } from '../transports/ab-config-transport'

class SessionClient {
    public getABConfig({ user }: { user: RequestUserConfig }): Promise<BaseTransport<ABConfigResponseTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
        }

        return NetworkService.get({
            url: `/api/v1/session/${user.session?.id}/ab-config`,
            headers,
        })
    }
}

export default new SessionClient()
